import {Component, Input} from '@angular/core';
import {ChartSignalEntry} from '@models/pages/user-defined-page/chart-signal-entry';
import {UserDefinedWidgetType} from '@constants/pages/user-defined-page/user-defined-widget-type';
import {
  ChartsConfigurationHelperService
} from '@services/charts/helper/charts-configuration-helper.service';
import {ChartGaugeType} from '@constants/pages/user-defined-page/chart-gauge-type';

@Component({
    selector: 'scitis-signal-slices-configuration',
    templateUrl: './signal-slices-configuration.component.html',
    styleUrls: ['./signal-slices-configuration.component.scss'],
    standalone: false
})
export class SignalSlicesConfigurationComponent {

  @Input()
  signal: ChartSignalEntry = new ChartSignalEntry();

  @Input()
  widgetType: UserDefinedWidgetType = UserDefinedWidgetType.GAUGE;

  constructor(private chartsConfigurationHelperService: ChartsConfigurationHelperService) {
  }

  public get isGaugeWidget(): boolean {
    return this.widgetType === UserDefinedWidgetType.GAUGE;
  }

  public get isModernGauge() {
    return this.signal.gaugeType === ChartGaugeType.MODERN;
  }

  onSelectSliceColor($event: string, slice: number) {
    switch (slice) {
      case 1:
        this.signal.colors.area1 = this.chartsConfigurationHelperService.convertHexColorToNumber($event);
        break;
      case 2:
        this.signal.colors.area2 = this.chartsConfigurationHelperService.convertHexColorToNumber($event);
        break;

      case 3:
        this.signal.colors.area3 = this.chartsConfigurationHelperService.convertHexColorToNumber($event);
        break;
    }

  }

  getHexColor(slice: number) {

    let color: number = 0;
    switch (slice) {
      case 1:
        color = this.signal.colors.area1;
        break;

      case 2:
        color = this.signal.colors.area2;
        break;

      case 3:
        color = this.signal.colors.area3;
        break;
    }
    return this.chartsConfigurationHelperService.convertNumberToHexColor(color);
  }

  settingValueChange(setting: string) {
    switch (setting) {
      case 'min': {
        this.updateMinValue();
        break;
      }
      case 'area1End': {
        this.area1ValueChangeEvaluation();
        break;
      }
      case 'area2End': {
        this.area2ValueChangeEvaluation();
        break;
      }
      case 'max': {
        this.updateMaxValue();
        break;
      }
    }
  }

  onColorTransitionChange($event: any) {
    if ($event && $event.target) {
      this.signal.transition = $event.target.checked;
    }
  }

  private updateMinValue() {
    const boundaries = this.signal.boundaries;

    if (boundaries.min >= boundaries.max) {
      boundaries.area1End = boundaries.min + 1;
      boundaries.area2End = boundaries.area1End + 1;
      boundaries.max = boundaries.area2End + 1;
    } else if (boundaries.min >= boundaries.area2End) {
      boundaries.area1End = boundaries.min + 1;
      boundaries.area2End = boundaries.area1End + 1;
      boundaries.max = boundaries.max <= boundaries.area2End ? boundaries.area2End + 1 : boundaries.max;
    } else if (boundaries.min >= boundaries.area1End) {
      boundaries.area1End = boundaries.min + 1;
      boundaries.area2End = boundaries.area2End <= boundaries.area1End ? boundaries.area1End + 1 : boundaries.area2End;
      boundaries.max = boundaries.max <= boundaries.area2End ? boundaries.area2End + 1 : boundaries.max;
    }
    this.signal.boundaries = boundaries;
  }

  private area1ValueChangeEvaluation() {
    const boundaries = this.signal.boundaries;

    if (boundaries.area1End <= boundaries.min) {
      boundaries.min = boundaries.area1End - 1;
    } else if (boundaries.area1End >= boundaries.max) {
      boundaries.area2End = boundaries.area1End + 1;
      boundaries.max = boundaries.area2End + 1;
    } else if (boundaries.area1End >= boundaries.area2End) {
      boundaries.area2End = boundaries.area1End + 1;
    }

    boundaries.max = boundaries.max <= boundaries.area2End ? boundaries.area2End + 1 : boundaries.max;
    this.signal.boundaries = boundaries;
  }

  private area2ValueChangeEvaluation() {
    const boundaries = this.signal.boundaries;

    if (boundaries.area2End >= boundaries.max) {
      boundaries.max = boundaries.area2End + 1;
    } else if (boundaries.area2End <= boundaries.min) {
      boundaries.min = boundaries.area1End - 1;
      boundaries.area1End = boundaries.area2End - 1;
    } else if (boundaries.area2End <= boundaries.area1End) {
      boundaries.area1End = boundaries.area2End - 1;
    }
    boundaries.min = boundaries.min >= boundaries.area1End ? boundaries.area1End - 1 : boundaries.min;
    this.signal.boundaries = boundaries;
  }

  private updateMaxValue() {
    const boundaries = this.signal.boundaries;
    if (boundaries.max <= boundaries.min) {
      boundaries.area2End = boundaries.max - 1;
      boundaries.area1End = boundaries.area2End - 1;
      boundaries.min = boundaries.area1End - 1;
    } else if (boundaries.max <= boundaries.area1End) {
      boundaries.area2End = boundaries.max - 1;
      boundaries.area1End = boundaries.area2End - 1;
      boundaries.min = boundaries.min >= boundaries.area1End ? boundaries.area1End - 1 : boundaries.min;
    } else if (boundaries.max <= boundaries.area2End) {
      boundaries.area2End = boundaries.max - 1;
      boundaries.area1End = boundaries.area1End >= boundaries.area2End ? boundaries.area2End - 1 : boundaries.area1End;
      boundaries.min = boundaries.min >= boundaries.area1End ? boundaries.area1End - 1 : boundaries.min;
    }
    this.signal.boundaries = boundaries;
  }

}
